import { createSlice } from '@reduxjs/toolkit'

export const loginSlice = createSlice({
  name: 'globals',
  initialState: {
      apiRoot: "https://bhco-api-staging.azurewebsites.net"
  }
})

export default loginSlice.reducer